// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__1Fx-1","text":"classes_text__25xqT"};